"use strict";Object.defineProperty(exports, "__esModule", {value: true}); const MAX_MESSAGE_LENGTH = 40000; exports.MAX_MESSAGE_LENGTH = MAX_MESSAGE_LENGTH
 const MAX_SMS_LENGTH = 1600; exports.MAX_SMS_LENGTH = MAX_SMS_LENGTH
